const isUndefined = require('lodash/isUndefined');
const isArray = require('lodash/isArray');
const template = require('lodash/template');
const find = require('lodash/find');
const makeSelectize = require('./makeSelectize.js');
const percentualRound = require('./percentualRound.js');
const to_array = require('./to_array');
const in_array = require('in_array');
const Lang = require('lang');
const makeRequestSelctize = require('./MakeRequestSelectize.js');
const calcCourseValue = require('../events/CalcCourseValue');
const ga4 = require('../ga4/ga4');

import hasDuplicated from './hasDuplicated.js';


/*
* Função para somar dois valores que possuem 2 casas decimais e evitar inconsistências de ponto flutuante do JavaScript
* @param {number} number1
* @param {number} number2
* @return {number}
*/
function sumValuesWithTwoDecimals(number1, number2) {
  const result = (number1 * 100 + number2 * 100) / 100;
  return parseFloat(result.toFixed(2));
}

function init(container, json) {
  const $container = $(container);

  if (!$container.length) {
    return;
  }

  if (isUndefined(json)) {
    json = isUndefined(window.dataRateio) ? false : window.dataRateio;
  }

  let selectizes = [];
  const form = $container.find('form');
  const rateio = $container.find('#despesas-container');
  const novosRateios = $container.find('#novosRateios');
  const rateioRequired = novosRateios.data('rateioRequired');
  const inputValor = $container.find('.valor-despesa');

  // Replace para remover erros no safari
  const template_string = $('#rateio').html().replace(/&gt;/g, '>').replace(/&lt;/g, '<');
  const _template = template(template_string);
  let rateioInput = {};
  let valorRateioInput = {};
  let count = 0;
  // usado para contar os rateios, para não ter mais de 30 e aplicar eventos
  // como mostrasr ou não botões de inserir/remover despesas
  let quantRateio = 0;

  const addRateioHandler = function () {
    ga4.event('expensesModal_addRateio')();
    form.data('canSendRateio', false)

    novosRateios.hide();
    $container.find('.remove').show();
    if (quantRateio < 50) {
      count++;
      quantRateio++;
      rateio.append(_template({
        count: count
      }));
      rateioInput = rateio.find('input.rateio-input');
      valorRateioInput = rateio.find('input.valor-rateio-input');

      // removendo botão de adicionar novos rateios caso utilize politica por projeto
      if (form.data('calculateValorKmPoliticaProjeto') != null) {
        $('#group' + count + ' .add').hide();
      }

      container.querySelector('#idEmpresaReembolsante' + count).addEventListener('change', calcCourseValue.handleCalc)
      container.querySelector('#group' + count + ' button.remove').addEventListener('click', calcCourseValue.handleCalcProjectPolicyRemoveProject)
      const select = $container.find('#idEmpresaReembolsante' + count);
      select.on('change', function (e) {
        ga4.event('-expenses_projectRateio')(this);
      });
      const $selectize = makeSelectize(select);

      selectizes.push($selectize);

      let value = 0;
      let total = 0;
      rateioInput.each(function (n, input) {
        value = 100 / rateioInput.length;
        value = percentualRound(value);

        // verifica se é o último elemento
        if (n + 1 === rateioInput.length) {
          // caso a soma do total com o último elemento
          // seja menor que 100 será calculado quanto
          // falta para dar 100, o valor será arredondado
          // e por fim incrementado no total
          if ((total + value) < 100) {
            value += (100 - (total + value));
            value = Math.round(value * 100) / 100;
          }
        }

        total += value;
        total = percentualRound(total)

        $(input).val(value.toFixed(2).replace('.', ','));
      });

      let amount = 0;
      let totalAmount = 0;
      valorRateioInput.each(function (n, input) {
        const valorDespesa = parseFloat(inputValor.val().replaceAll('.', '').replace(',', '.')) || 0;

        if (valorDespesa != 0) {
          if ($(input).attr('disabled')) {
            $(input).prop('disabled', false);
          }

          amount = valorDespesa / valorRateioInput.length;
          amount = percentualRound(amount);

          // verifica se é o último elemento
          if (n + 1 === valorRateioInput.length) {
            // caso a soma do total com o último elemento
            // seja menor que o valor da despesa será calculado quanto
            // falta para dar esse valor, o valor será arredondado
            // e por fim incrementado no total
            if ((totalAmount + amount) < valorDespesa) {
              amount += (valorDespesa - (totalAmount + amount));
              amount = Math.round(amount * 100) / 100;
            }
          }

          totalAmount += amount;
        } else {
          if (!$(input).attr('disabled')) {
            $(input).attr('disabled', true);
          }
        }

        $(input).val(amount.toFixed(2).replace('.', ','));
        $(input).trigger('change');
      });

      makeRequestSelctize.init($selectize);
    } else {
      bootbox.alert(Lang.get('js/src/functions/rateioInput.not_allowed_to_add_apportionment'))
        .on('hidden.bs.modal', function () {
          $container.hasClass('modal') && nifty.body.addClass('modal-open');
        })
    }

    refreshLabelRateio();
    rateio.scrollTop(Number.MAX_SAFE_INTEGER);
  };

  const removeRateioHandler = function (e) {
    ga4.event('-expensesModal_removeRateio')();
    form.data('canSendRateio', false)

    // Removing the removed selectize from the selectizes array
    selectizes = selectizes.filter(selectize => {
      const selectizeId = selectize.$input.attr('id')
      const removedId = $(e.currentTarget)
        .closest('.rateio')
        .find('.selectized')
        .attr('id');

      return selectizeId !== removedId;
    });

    quantRateio--;
    if (quantRateio <= 0) {
      novosRateios.show();
    }

    if (rateioRequired) {
      if (quantRateio === 1) {
        $container.find('.remove').hide();
      } else {
        $container.find('.remove').show();
      }
    }

    const button = $(e.target)[0].localName === 'button' ? $(e.target) : $(e.target).closest('button');
    const group = '#group' + button.attr('data-count');
    rateio.find(group).remove();
    rateioInput = rateio.find('input.rateio-input');
    valorRateioInput = rateio.find('input.valor-rateio-input');

    let total = 0;
    let value = 0;
    rateioInput.each(function (n, input) {
      value = 100 / rateioInput.length;
      value = percentualRound(value);
      total += value;
      if (n + 1 === rateioInput.length) {
        if (total < 100) {
          value += 100 - total;
          value = Math.round(value * 100) / 100;
        }
      }
      $(input).val(value.toFixed(2).replace('.', ','));
    });

    let totalAmount = 0;
    let amount = 0;
    valorRateioInput.each(function (n, input) {
      const valorDespesa = parseFloat(inputValor.val().replaceAll('.', '').replace(',', '.')) || 0;

      if (valorDespesa != 0) {
        if ($(input).attr('disabled')) {
          $(input).prop('disabled', false);
        }

        amount = valorDespesa / valorRateioInput.length;
        amount = percentualRound(amount);
        totalAmount += amount;

        if (n + 1 === valorRateioInput.length) {
          if (totalAmount < valorDespesa) {
            amount += valorDespesa - totalAmount;
            amount = Math.round(amount * 100) / 100;
          }
        }
      } else {
        if (!$(input).attr('disabled')) {
          $(input).attr('disabled', true);
        }
      }

      $(input).val(amount.toFixed(2).replace('.', ','));
      $(input).trigger('change');
    });

    refreshLabelRateio();
  };

  $container.on('keyup', '.valor-rateio-input', function (event) {
    const inputValor = $container.find('.valor-despesa');
    const rateioInput = $container.find('input.rateio-input');
    const valorRateioInput = $container.find('input.valor-rateio-input');
    const valorDespesa = parseFloat(inputValor.val().replaceAll('.', '').replace(',', '.')) || 0;
    const actualAmount = parseFloat(event.target.value.replace('.', '').replace(',', '.')) || 0;
    let percentage = isFinite(actualAmount / valorDespesa) ? (actualAmount / valorDespesa) * 100 : 0;

    const inputNumber = event.target.id.substring(11);
    const percentageInput = $container.find('#rateio' + inputNumber);

    let sumAmount = 0;
    valorRateioInput.each(function () {
      sumAmount += +parseFloat($(this).val().replaceAll('.', '').replace(',', '.'));
    });

    $(percentageInput).val(percentage.toFixed(2).replace('.', ','));

    if (sumAmount == valorDespesa) {
      let sumPercentage = 0;
      rateioInput.each(function () {
        sumPercentage += +parseFloat($(this).val().replaceAll('.', '').replace(',', '.'));
      });

      if (sumPercentage !== 100) {
        const diff = sumPercentage - 100;
        percentage = percentage - diff;
        $(percentageInput).val(percentage.toFixed(2).replace('.', ','));
      }
    }
  });

  $container.on('keyup', '.rateio-input', function (event) {
    ga4.event('-expensesModal_percentageRateio')(this);
    const inputValor = $container.find('.valor-despesa');
    const rateioInput = $container.find('input.rateio-input');
    const valorRateioInput = $container.find('input.valor-rateio-input');
    const valorDespesa = parseFloat(inputValor.val().replaceAll('.', '').replace(',', '.')) || 0;
    const actualValue = parseFloat(event.target.value.replace('.', '').replace(',', '.')) || 0;
    let value = (valorDespesa / 100) * actualValue;

    const inputNumber = event.target.id.substring(6);
    const valueInput = $container.find('#valorRateio' + inputNumber);

    let sumPercentage = 0;
    rateioInput.each(function () {
      sumPercentage += +parseFloat($(this).val().replaceAll('.', '').replace(',', '.'));
    });

    $(valueInput).val(value.toFixed(2).replace('.', ','));

    if (sumPercentage == 100) {
      let sumAmount = 0;
      valorRateioInput.each(function () {
        sumAmount += +parseFloat($(this).val().replaceAll('.', '').replace(',', '.'));
      });

      if (sumAmount !== valorDespesa) {
        const diff = sumAmount - valorDespesa;
        value = value - diff;
        $(valueInput).val(value.toFixed(2).replace('.', ','));
      }
    }
  });

  $container.on('keyup change', '.valor-despesa', function (event) {
    const inputValor = $(event.target);
    const rateioInput = $container.find('input.rateio-input');
    const valorRateioInput = $container.find('input.valor-rateio-input');
    const valorDespesa = parseFloat(inputValor.val().replaceAll('.', '').replace(',', '.')) || 0;

    let sumPercentage = 0;
    rateioInput.each(function (n, input) {
      const percentual = parseFloat($(input).val().replace('.', '').replace(',', '.')) || 0;
      let value = (valorDespesa / 100) * percentual;

      const inputNumber = input.id.substring(6);
      const valueInput = $container.find('#valorRateio' + inputNumber);

      if (valorDespesa != 0) {
        $(valueInput).prop('disabled', false);
      } else {
        $(valueInput).prop('disabled', true);
      }

      // $(valueInput).val(value.toFixed(2).replace('.', ','));

      $(valueInput).val(inputValor.val());

      sumPercentage += +parseFloat($(this).val().replaceAll('.', '').replace(',', '.'));

      if (sumPercentage == 100) {
        let sumAmount = 0;
        valorRateioInput.each(function () {
          sumAmount += +parseFloat($(this).val().replaceAll('.', '').replace(',', '.'));
        });

        if (sumAmount !== valorDespesa) {
          const diff = sumAmount - valorDespesa;
          value = value - diff;
          $(valueInput).val(value.toFixed(2).replace('.', ','));
        }
      }
    });
  });

  /**
   * Atualizar a label dos rateios
   */
  const refreshLabelRateio = function () {
    const containerRateios = $container.find('#despesas-container')[0];

    if (!document.body.contains(containerRateios)) {
      return;
    }

    const labelsRateio = containerRateios.querySelectorAll('strong');
    if (!labelsRateio.length) {
      return;
    }

    labelsRateio.forEach((currentElement, index) => {
      const textRateio = Lang.get('js/common/phrases.apportionment');
      currentElement.innerText = `${textRateio} ${index + 1}`;
    });
  }

  $container.on('click', '.add', addRateioHandler);
  $container.on('click', '.remove', removeRateioHandler);

  if (in_array($container.attr('id'), ['percurso', 'modal-percurso', 'modal-mapa-percurso'])) {
    form.data('canSend', true);
  }

  form.on('submit', function (e) {
    if (form.data('canSendRateio')) {
      return true;
    }

    if (!form.data('canSend')) {
      form.overlay('hide');
      return false;
    }

    e.preventDefault();
    e.stopPropagation();

    let empresas = [];

    if (rateioInput.length) {
      const idContainer = $container.attr('id');

      // Removendo da lista de inputs selectize de
      // empresa pagante, aquelas correspondentes aos
      // componentes excluidos por outras interações
      selectizes = selectizes.filter(selectize => {
        const element = document.querySelector('#' + idContainer + ' #' + selectize.$input.attr('id'));

        if (document.body.contains(element)) {
          return selectize;
        }
      });

      empresas = selectizes.map(selectize => Number(selectize.getValue()));

      if (empresas.includes(0)) {
        bootbox.alert({
          title: Lang.get('js/src/functions/rateioInput.invalid_apportionment'),
          message: Lang.get('js/src/functions/rateioInput.apportionment_with_no_company_selected')
        })
          .on('hidden.bs.modal', function () {
            $container.hasClass('modal') && nifty.body.addClass('modal-open');
          })

        form.overlay('hide');

        return false;
      }

      if (hasDuplicated(empresas)) {
        bootbox.alert({
          title: Lang.get('js/src/functions/rateioInput.invalid_apportionment'),
          message: Lang.get('js/src/functions/rateioInput.company_duplicated_on_apportionment')
        })
          .on('hidden.bs.modal', function () {
            $container.hasClass('modal') && nifty.body.addClass('modal-open');
          })

        form.overlay('hide');

        return false;
      }

      const wrongPercentage = rateioInput.filter(input => {
        return input.value == 0;
      });

      if (wrongPercentage.length > 0) {
        bootbox.alert({
          title: Lang.get('js/src/functions/rateioInput.invalid_apportionment'),
          message: Lang.get('js/src/functions/rateioInput.percentage_must_be_greater_than_zero')
        })
        return false;
      }

      let percentage = to_array(rateioInput)
        .map(input => {
          let valorString = input.value.replace(/(\.|\,)/g, '');
          if (valorString.length === 2) {
            valorString += '00';
          }
          return parseInt(valorString);
        })
        .reduce((percentage, value) => {
          return percentage + value
        });

      percentage = percentage / 100;

      if (percentage != 100) {
        bootbox.alert({
          title: Lang.get('js/src/functions/rateioInput.invalid_apportionment'),
          message: Lang.get('js/src/functions/rateioInput.invalid_apportionment_sum')
        });

        form.overlay('hide');

        return false;
      }
    }

    if (form.valid()) {
      form.data('canSendRateio', true);
      form.trigger('submit');
    }
  });

  if (isArray(json) && json.length) {
    novosRateios.hide();

    json.forEach(function (item, n) {
      const inputId = '#idEmpresaReembolsante' + count;

      rateio.append(_template({
        count: count
      }));

      const rateioById = rateio.find('#rateio' + count);
      const valorRateioInput = rateio.find('#valorRateio' + count);
      const uuidById = rateio.find('#uuidRateio' + count);
      const inputValor = $('.valor-despesa');

      const rateioByIdFormatted = parseFloat(item.percentual).toFixed(2).replace('.', ',');
      rateioById.val(rateioByIdFormatted);

      // verifica se é o último elemento e se tem mais de um elemento
      if (json.length > 1 && n + 1 === json.length) {
        // calcula a soma dos percentuais
        const sum = json.slice(0, -1).reduce((acc, current) => {
          const percentualWithTwoDecimals = parseFloat(current.percentual).toFixed(2);
          return sumValuesWithTwoDecimals(acc, parseFloat(percentualWithTwoDecimals));
        }, 0);

        // calcula o percentual do último elemento
        const lastPercentage = sumValuesWithTwoDecimals(100, -sum);
        const lastPercentageFormatted = lastPercentage.toFixed(2).replace('.', ',');

        rateioById.val(lastPercentageFormatted);
      }

      const valorDespesa = parseFloat(inputValor.val().replaceAll('.', '').replace(',', '.')) || 0;
      const valorRateio = (valorDespesa / 100) * item.percentual;
      valorRateioInput.val(valorRateio.toFixed(2));
      $(valorRateioInput).trigger('change');

      if (valorDespesa != 0) {
        $(valorRateioInput).prop('disabled', false);
      } else {
        $(valorRateioInput).prop('disabled', true);
      }

      uuidById.attr('name', 'uuidRateio[' + item.idEmpresaReembolsante + ']')
      uuidById.val(item.uuid);

      rateioInput = rateio.find('input.rateio-input');

      const options = document.querySelectorAll(inputId + ' > option');

      if (!find(options, 'value', item.idEmpresaReembolsante.toString())) {
        const newOption = document.createElement('option');
        const select = document.getElementById(inputId.replace('#', ''));
        newOption.value = item.idEmpresaReembolsante;
        newOption.innerText = item.reembolsante.nome;
        select && select.appendChild(newOption);
      };

      $(inputId).on('change', function () {
        ga4.event('-expenses_projectRateio')(this);
      });
      const $selectize = makeSelectize(inputId);
      selectizes.push($selectize);
      $selectize.setValue(item.idEmpresaReembolsante);
      document.querySelector('#idEmpresaReembolsante' + count).addEventListener('change', calcCourseValue.handleCalc)
      count++;
      quantRateio++;
      makeRequestSelctize.init($selectize);
    });

    if (json.length == 1 && rateioRequired) {
      rateio.find('.remove').hide();
    }
  } else if (rateioRequired) {
    addRateioHandler();
    $container.find('.remove').hide();
  }
}

/**
 * Validação das inputs de rateios
 *
 * Este método verifica  se existe rateio sem empresa selecionada
 * e se o valor da soma dos rateios é de 100%
 *
 * @param {Element} form
 */
function validate(form) {
  const rateioInput = to_array(form.querySelectorAll('[name="rateio[]"]'));
  const valorRateioInput = to_array(form.querySelectorAll('[name="valorRateio[]"]'));
  const selectizes = to_array(form.querySelectorAll('[name="idEmpresaReembolsante[]"]'));
  const inputValor = form.querySelector('.valor-despesa');
  const valorDespesa = parseFloat(inputValor.value.replaceAll('.', '').replace(',', '.')) || 0;

  if (!rateioInput.length) {
    return true;
  }

  const empresas = selectizes.map(currentSelectize => Number(currentSelectize.value));

  if (empresas.includes(0)) {
    bootbox.alert({
      title: Lang.get('js/src/functions/rateioInput.invalid_apportionment'),
      message: Lang.get('js/src/functions/rateioInput.apportionment_with_no_project_selected')
    });

    return false;
  }

  if (hasDuplicated(empresas)) {
    bootbox.alert({
      title: Lang.get('js/src/functions/rateioInput.invalid_apportionment'),
      message: Lang.get('js/src/functions/rateioInput.company_duplicated_on_apportionment')
    })

    return false;
  }

  const wrongPercentage = rateioInput.filter(input => {
    return input.value == 0;
  });

  if (wrongPercentage.length > 0) {
    bootbox.alert({
      title: Lang.get('js/src/functions/rateioInput.invalid_apportionment'),
      message: Lang.get('js/src/functions/rateioInput.percentage_must_be_greater_than_zero')
    })
    return false;
  }

  const percentage = rateioInput
    .map(input => parseFloat(input.value.replace(',', '.')) * 100)
    .reduce((percentage, value) => sumValuesWithTwoDecimals(percentage, value)) / 100;

  if (percentage != 100) {
    bootbox.alert({
      title: Lang.get('js/src/functions/rateioInput.invalid_apportionment'),
      message: Lang.get('js/src/functions/rateioInput.invalid_apportionment_sum')
    });

    return false;
  }

  const amount = valorRateioInput
    .map(input => parseFloat(input.value.replaceAll('.', '').replace(',', '.')) * 100)
    .reduce((amount, value) => amount + value) / 100;

  if (amount < valorDespesa) {
    bootbox.alert({
      title: Lang.get('js/src/functions/rateioInput.invalid_apportionment'),
      message: Lang.get('js/src/functions/rateioInput.invalid_apportionment_amount_sum')
    });

    return false;
  }

  return true;
}

module.exports = {
  init: init,
  validate: validate
};
